import React, { useState, useEffect } from "react";
import { Dropdown, Form } from "react-bootstrap";
import { ProgramDropdown, TimesheetTaskDropdown } from "CommonDropdowns";
import { map, set } from "lodash";
import moment from "moment";
import { useSelector } from "react-redux";
import { InformationMsg } from "../";
import { getWeekEndingDates } from "utils/general";

const Filter = ({
  onFilter,
  extraFiltersState,
  setExtraFiltersState,
  currentWeek,
  setCurrentWeek,
  setWeekValue,
}) => {

  const session = useSelector(state => state.session);

  const [show, setShow] = useState(false);
  const [programValue, setProgramValue] = useState([]);
  const [taskValue, setTaskValue] = useState([]);
  const [weekOptions, setWeekOptions] = useState([]);

 useEffect(() => {
  const weeks = getWeekEndingDates();
  setWeekOptions(weeks);

  const currentWeekEnding = moment().endOf("isoWeek").format("YYYY-MM-DD");

  setCurrentWeek(currentWeekEnding);

  // update filters
  setExtraFiltersState((prev) => ({
    ...prev,
    values: { ...prev.values, week_end_date: currentWeekEnding },
  }));

 
  setWeekValue(
    `Week Ending ${moment(currentWeekEnding, "YYYY-MM-DD").format("MM/DD/YYYY")}`
  );
}, []);




  const handleToggle = (isOpen) => {
    setShow(isOpen);
  };

  const handleClear = () => {
    setExtraFiltersState({ values: {} });
    setProgramValue([]);
    setTaskValue([]);
    setShow(false);
  };

  const handleSearch = () => {
    onFilter();
    setShow(false);
  };

  const handleCancel = () => {
    setShow(false);
  };

  const handleProgramChange = (selected) => {
    setProgramValue(selected);
    const programIds = map(selected, "value");
    setExtraFiltersState((prev) => ({
      ...prev,
      values: { ...prev.values, program_id: programIds, task_ids: [] },
    }));
    setTaskValue([]);
  };

  const handleTaskChange = (selected) => {
    setTaskValue(selected);
    const taskIds = map(selected, "value");
    setExtraFiltersState((prev) => ({
      ...prev,
      values: { ...prev.values, task_ids: taskIds },
    }));
  };

 const handleChange = (event) => {
  const value = event.target.value;

  setExtraFiltersState((prev) => ({
    ...prev,
    values: { ...prev.values, [event.target.name]: value },
  }));

  // send formatted week to parent
  if (event.target.name === "week_end_date") {
    setWeekValue(
      `Week Ending ${moment(value, "YYYY-MM-DD").format("MM/DD/YYYY")}`
    );
  }
};


  return (
    <>
    {/*<Dropdown
      show={show}
      onToggle={handleToggle}
      align="end"
      className="filters-dropdown"
    >
      <Dropdown.Toggle
        variant="light"
        className="d-flex align-items-center gap-2"
      >
        <img src="/assets/images/filter-icon.svg" alt="filter" /> Filters
      </Dropdown.Toggle>

      <Dropdown.Menu className="p-4" style={{ minWidth: "350px" }}> */}
      <>
        <div className="row m-4">
          <div className="col-md-6">
            <InformationMsg />
          </div>
          
        </div>
        <Form>
          <div className="row filters-flex">
            

          <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label className="label-input">Week Ending</Form.Label>
                <Form.Select
                  className="input-field"
                  name="week_end_date"
                  onChange={handleChange}
                  value={extraFiltersState.values.week_end_date || ""}
                >
                  <option value="">Select Week</option>
                  {weekOptions.map((week_end_date) => (
                    <option key={week_end_date} value={week_end_date}>
                      Week Ending{" "}
                      {moment(week_end_date, "YYYY-MM-DD").format("MM/DD/YYYY")}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </div>

            
            <div className="col-md-3">
              <ProgramDropdown
                programValue={programValue}
                programOnChange={handleProgramChange}
                setProgramValue={setProgramValue}
                isMulti={true}
                selectedId={extraFiltersState.values.program_id}
                user_id={session?.user?.id || null} 
              />
            </div>

            {programValue && programValue.length > 0 && (
              <div className="col-md-3">
                <TimesheetTaskDropdown
                  taskValue={taskValue}
                  taskOnChange={handleTaskChange}
                  setTaskValue={setTaskValue}
                  isMulti={true}
                  name="task_ids"
                  programId={extraFiltersState.values.program_id}
                  selectedId={extraFiltersState.values.task_ids}
                />
              </div>
            )}

            

            <div className="col-md-3">
              <Form.Label className="label-input">&nbsp; </Form.Label>
              <button
                type="button"
                onClick={handleSearch}
                className="add-new-btn w-100"
              >
                <img
                  src="/assets/images/search-white.svg"
                  alt=""
                  className="me-2"
                />
                Search
              </button>
            </div>
          </div>

          
        </Form>

      </>  
      {/*</Dropdown.Menu>
    </Dropdown>*/}
    </>
  );
};

export default Filter;
